const scrollTo = (top: number, headerSize: number) => {
  window.scrollTo({
    top: window.scrollY + top - headerSize - 5,
    behavior: 'smooth',
  });
};

export default function scrollOnError() {
  const errorMessages = document.getElementsByClassName('error-message');
  const headerSize = document
    .getElementsByTagName('header')[0]
    .getBoundingClientRect().height;
  const rect =
    errorMessages && errorMessages.length
      ? errorMessages[0].getBoundingClientRect()
      : false;
  rect && scrollTo(rect.top, headerSize);
}
